import React from 'react';

interface Props {
	name: string;
}

/**
 * A component that provides Apex icons as inline svg's.
 * All svg details are taken from the Master Apex Group Design Assets Figma document,
 * currently located at
 * https://www.figma.com/design/ubPz8JGThVmJL6hW5FdKLt/Master-Apex-Group-Design-Assets--DO-NOT-EDIT-
 * at the time of writing this doco.
 */
export class ApexIconReact extends React.Component<Props> {
	public render() {
		switch (this.props.name) {
			case 'key-01':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M17.8564 8.99994C17.8564 8.48812 17.6612 7.9763 17.2707 7.58579C16.8801 7.19526 16.3683 7 15.8564 7M15.8564 15C19.1702 15 21.8564 12.3137 21.8564 9C21.8564 5.68629 19.1702 3 15.8564 3C12.5427 3 9.85645 5.68629 9.85645 9C9.85645 9.27368 9.87477 9.54308 9.91026 9.80704C9.96862 10.2412 9.99781 10.4583 9.97816 10.5956C9.9577 10.7387 9.93165 10.8157 9.86113 10.9419C9.79344 11.063 9.67416 11.1823 9.43558 11.4209L4.32507 16.5314C4.15212 16.7043 4.06565 16.7908 4.00381 16.8917C3.94898 16.9812 3.90857 17.0787 3.88408 17.1808C3.85645 17.2959 3.85645 17.4182 3.85645 17.6627V19.4C3.85645 19.9601 3.85645 20.2401 3.96544 20.454C4.06131 20.6422 4.21429 20.7951 4.40245 20.891C4.61637 21 4.89639 21 5.45645 21H7.85645V19H9.85645V17H11.8564L13.4356 15.4209C13.6742 15.1823 13.7934 15.063 13.9145 14.9953C14.0407 14.9248 14.1178 14.8987 14.2609 14.8783C14.3982 14.8586 14.6153 14.8878 15.0494 14.9462C15.3134 14.9817 15.5828 15 15.8564 15Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'log-in-01':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M15.8564 3H17.0564C18.7366 3 19.5767 3 20.2184 3.32698C20.7829 3.6146 21.2418 4.07354 21.5295 4.63803C21.8564 5.27976 21.8564 6.11985 21.8564 7.8V16.2C21.8564 17.8802 21.8564 18.7202 21.5295 19.362C21.2418 19.9265 20.7829 20.3854 20.2184 20.673C19.5767 21 18.7366 21 17.0564 21H15.8564M10.8564 7L15.8564 12M15.8564 12L10.8564 17M15.8564 12L3.85645 12"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'user-square':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M4.85647 21.8174C5.45905 22 6.27294 22 7.65645 22H18.0564C19.44 22 20.2538 22 20.8564 21.8174M4.85647 21.8174C4.72727 21.7783 4.60778 21.7308 4.49447 21.673C3.92999 21.3854 3.47105 20.9265 3.18343 20.362C2.85645 19.7202 2.85645 18.8802 2.85645 17.2V6.8C2.85645 5.11984 2.85645 4.27976 3.18343 3.63803C3.47105 3.07354 3.92999 2.6146 4.49447 2.32698C5.13621 2 5.97629 2 7.65645 2H18.0564C19.7366 2 20.5767 2 21.2184 2.32698C21.7829 2.6146 22.2418 3.07354 22.5295 3.63803C22.8564 4.27976 22.8564 5.11984 22.8564 6.8V17.2C22.8564 18.8802 22.8564 19.7202 22.5295 20.362C22.2418 20.9265 21.7829 21.3854 21.2184 21.673C21.1051 21.7308 20.9856 21.7783 20.8564 21.8174M4.85647 21.8174C4.8568 21.0081 4.86165 20.5799 4.9333 20.2196C5.24893 18.6329 6.48932 17.3925 8.07608 17.0769C8.46248 17 8.92713 17 9.85645 17H15.8564C16.7858 17 17.2504 17 17.6368 17.0769C19.2236 17.3925 20.464 18.6329 20.7796 20.2196C20.8512 20.5799 20.8561 21.0081 20.8564 21.8174M16.8564 9.5C16.8564 11.7091 15.0656 13.5 12.8564 13.5C10.6473 13.5 8.85645 11.7091 8.85645 9.5C8.85645 7.29086 10.6473 5.5 12.8564 5.5C15.0656 5.5 16.8564 7.29086 16.8564 9.5Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'user-circle':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M6.17274 19.4384C6.78107 18.0052 8.20137 17 9.85645 17H15.8564C17.5115 17 18.9318 18.0052 19.5401 19.4384M16.8564 9.5C16.8564 11.7091 15.0656 13.5 12.8564 13.5C10.6473 13.5 8.85645 11.7091 8.85645 9.5C8.85645 7.29086 10.6473 5.5 12.8564 5.5C15.0656 5.5 16.8564 7.29086 16.8564 9.5ZM22.8564 12C22.8564 17.5228 18.3793 22 12.8564 22C7.3336 22 2.85645 17.5228 2.85645 12C2.85645 6.47715 7.3336 2 12.8564 2C18.3793 2 22.8564 6.47715 22.8564 12Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'help-circle':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M9.94645 9C10.1815 8.33167 10.6456 7.76811 11.2564 7.40913C11.8672 7.05016 12.5853 6.91894 13.2836 7.03871C13.9819 7.15849 14.6153 7.52152 15.0715 8.06353C15.5278 8.60553 15.7775 9.29152 15.7764 10C15.7764 12 12.7764 13 12.7764 13M12.8564 17H12.8664M22.8564 12C22.8564 17.5228 18.3793 22 12.8564 22C7.3336 22 2.85645 17.5228 2.85645 12C2.85645 6.47715 7.3336 2 12.8564 2C18.3793 2 22.8564 6.47715 22.8564 12Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'book-closed':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M20.8564 19V16H7.85645C6.19959 16 4.85645 17.3431 4.85645 19M9.65645 22H17.6564C18.7766 22 19.3366 22 19.7644 21.782C20.1408 21.5903 20.4467 21.2843 20.6385 20.908C20.8564 20.4802 20.8564 19.9201 20.8564 18.8V5.2C20.8564 4.07989 20.8564 3.51984 20.6385 3.09202C20.4467 2.71569 20.1408 2.40973 19.7644 2.21799C19.3366 2 18.7766 2 17.6564 2H9.65645C7.97629 2 7.13621 2 6.49447 2.32698C5.92999 2.6146 5.47105 3.07354 5.18343 3.63803C4.85645 4.27976 4.85645 5.11984 4.85645 6.8V17.2C4.85645 18.8802 4.85645 19.7202 5.18343 20.362C5.47105 20.9265 5.92999 21.3854 6.49447 21.673C7.13621 22 7.97629 22 9.65645 22Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'info-circle':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M12.8564 16V12M12.8564 8H12.8664M22.8564 12C22.8564 17.5228 18.3793 22 12.8564 22C7.3336 22 2.85645 17.5228 2.85645 12C2.85645 6.47715 7.3336 2 12.8564 2C18.3793 2 22.8564 6.47715 22.8564 12Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'star-01':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M12.1391 3.45307C12.3696 2.98613 12.4848 2.75266 12.6413 2.67807C12.7774 2.61317 12.9355 2.61317 13.0717 2.67807C13.2281 2.75266 13.3433 2.98613 13.5738 3.45307L15.7605 7.88304C15.8286 8.02089 15.8626 8.08982 15.9123 8.14333C15.9563 8.19071 16.0091 8.22911 16.0678 8.25638C16.134 8.28718 16.2101 8.2983 16.3622 8.32053L21.2534 9.03546C21.7685 9.11075 22.026 9.14839 22.1452 9.27419C22.2489 9.38365 22.2977 9.53405 22.278 9.68353C22.2553 9.85533 22.0688 10.0369 21.6959 10.4001L18.1579 13.8462C18.0476 13.9536 17.9925 14.0073 17.9569 14.0712C17.9254 14.1278 17.9052 14.19 17.8974 14.2543C17.8886 14.3269 17.9016 14.4027 17.9276 14.5545L18.7624 19.4219C18.8505 19.9352 18.8945 20.1919 18.8117 20.3443C18.7398 20.4768 18.6118 20.5697 18.4635 20.5972C18.2931 20.6288 18.0626 20.5076 17.6016 20.2652L13.2288 17.9656C13.0926 17.8939 13.0245 17.8581 12.9527 17.844C12.8891 17.8316 12.8238 17.8316 12.7602 17.844C12.6885 17.8581 12.6203 17.8939 12.4841 17.9656L8.11137 20.2652C7.65036 20.5076 7.41986 20.6288 7.24942 20.5972C7.10113 20.5697 6.97317 20.4768 6.90118 20.3443C6.81845 20.1919 6.86247 19.9352 6.95052 19.4219L7.78533 14.5545C7.81136 14.4027 7.82437 14.3269 7.81557 14.2543C7.80777 14.19 7.78756 14.1278 7.75605 14.0712C7.72047 14.0073 7.66532 13.9536 7.55503 13.8462L4.017 10.4001C3.64411 10.0369 3.45766 9.85533 3.43497 9.68353C3.41523 9.53405 3.464 9.38365 3.5677 9.27419C3.68688 9.14839 3.94442 9.11075 4.45949 9.03546L9.35076 8.32053C9.50287 8.2983 9.57893 8.28718 9.64516 8.25638C9.70381 8.22911 9.75661 8.19071 9.80063 8.14333C9.85035 8.08982 9.88437 8.02089 9.95242 7.88304L12.1391 3.45307Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'compass-03':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M12.8564 22C18.3793 22 22.8564 17.5228 22.8564 12C22.8564 6.47715 18.3793 2 12.8564 2C7.3336 2 2.85645 6.47715 2.85645 12C2.85645 17.5228 7.3336 22 12.8564 22Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M15.5786 8.26596C16.0671 8.10312 16.3114 8.02169 16.4738 8.07962C16.6152 8.13003 16.7264 8.24127 16.7768 8.38263C16.8348 8.54507 16.7533 8.78935 16.5905 9.27789L15.1029 13.7405C15.0566 13.8797 15.0334 13.9492 14.9938 14.007C14.9588 14.0582 14.9146 14.1024 14.8635 14.1374C14.8057 14.1769 14.7361 14.2001 14.597 14.2465L10.1343 15.734C9.64579 15.8969 9.40152 15.9783 9.23908 15.9204C9.09771 15.87 8.98647 15.7587 8.93606 15.6174C8.87814 15.4549 8.95956 15.2107 9.12241 14.7221L10.61 10.2595C10.6563 10.1203 10.6795 10.0508 10.719 9.99299C10.754 9.94182 10.7983 9.8976 10.8494 9.8626C10.9072 9.82308 10.9768 9.79989 11.1159 9.75351L15.5786 8.26596Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'clock-rewind':
				return (
					<svg viewBox="0 0 23 20" fill="none">
						<path
							d="M21.5564 11.5L19.557 9.5L17.5564 11.5M19.8564 10C19.8564 14.9706 15.827 19 10.8564 19C5.88588 19 1.85645 14.9706 1.85645 10C1.85645 5.02944 5.88588 1 10.8564 1C14.1584 1 17.045 2.77814 18.611 5.42909M10.8564 5V10L13.8564 12"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case 'log-out-01':
				return (
					<svg viewBox="0 0 25 24" fill="none">
						<path
							d="M16.8564 17L21.8564 12M21.8564 12L16.8564 7M21.8564 12H9.85645M9.85645 3H8.65645C6.97629 3 6.13621 3 5.49447 3.32698C4.92999 3.6146 4.47105 4.07354 4.18343 4.63803C3.85645 5.27976 3.85645 6.11984 3.85645 7.8V16.2C3.85645 17.8802 3.85645 18.7202 4.18343 19.362C4.47105 19.9265 4.92999 20.3854 5.49447 20.673C6.13621 21 6.97629 21 8.65645 21H9.85645"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			default:
				return null;
		}
	}
}
